export default "__VITE_ASSET__1705f54a__"